import React from 'react';
import CallHistory from '../components/callHistory';
import { injectIntl } from "react-intl";
import { withTheme } from 'styled-components';

import useCallInfo from '../hooks/callInfo';

const History = injectIntl(({ history, match, intl, theme }) => {

  const [/* callInfo */, { makeCall }] = useCallInfo();

  const handleGoBackClick = () => {
    history.goBack();
  };

  const handleHistoryItemClick = (number) => {
    // console.log("handling history item click", number);
    // call the number
    makeCall(number);
    // change route to callprogress
    history.push('/callprogress');
  };

  return (
    <div className="historyRoute">
      <CallHistory
        intl={intl}
        cbOnClose={handleGoBackClick}
        cbOnClick={handleHistoryItemClick}
        theme={theme}
      />
    </div >
  );

});


export default withTheme(History);